module.exports = __webpack_public_path__ + "img/pr-1.4444a678.png";